window.VIRUS_PRODUCT = window.VIRUS_PRODUCT || {
  id: 8926293491902,
  handle: "gildan-mens-tshirt",
  file: "VIRUS_001",
  name: "VIRUS_001 — WHITE",
  price: 5555,
  priceLabel: "$55.55",
  color: "white",
  blurb: "First strain. VIRUS_001 — WHITE. Escaped the lab. Spread the virus.",
  fabric: "Gildan heavy cotton",
  shots: [
    { src: "assets/images/virus001-d.png", caption: "BACK // PAYLOAD" },
    { src: "assets/images/virus001-a.png", caption: "FRONT // FIELD" }
  ],
  variants: [
    { size: "S", id: "48758424731838" },
    { size: "M", id: "48758424764606" },
    { size: "L", id: "48758424797374" },
    { size: "XL", id: "48758424830142" },
    { size: "XXL", id: "48758424862910" }
  ]
};
